import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';
import {
  Wallet,
  Calendar,
  DollarSign,
  Building2,
  TrendingUp,
  CheckCircle,
  AlertCircle
} from 'lucide-react';

const ModalUploadRentalsExpenseForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;
    const [companyID] = useState(1);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [businessLocationID, setBusinessLocationID] = useState('');
  const [expense, setExpense] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [years, setYears] = useState([]);

  const business_locationIDMain = localStorage.getItem('business_locationIDMain') || '';
  let userCompanyID = localStorage.getItem('companyID');
  if(userCompanyID === 'Admin'){
    userCompanyID = 1;
  }

  useEffect(() => {
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationHousesOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", business_locationIDMain);
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setBusinessLocations(response.data);
      })
      .catch(error => {
        setError("Failed to load business locations");
      });
  }, []);

  useEffect(() => {
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationExpensesOnUploadForm');
    formData.append("companyID", userCompanyID);
    formData.append("location", business_locationIDMain);
    
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setExpenses(response.data);
      })
      .catch(error => {
        setError("Failed to load expenses");
      });

    const currentYear = new Date().getFullYear();
    const futureYears = Array.from({ length: 2100 - currentYear }, (_, i) => currentYear + i);
    setYears(futureYears);
  }, []);

  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    if (businessLocationID && expense && month && year && amount) {
      const formData = new FormData();
      formData.append('business_locationIDExpenseRentals', businessLocationID);
      formData.append('companyIDExpenseRentals', window.userCompanyID);
      formData.append('userIDRentalExpenses', window.userID);
      formData.append('expenseRentals', expense);
      formData.append('monthExpenseRentals', month);
      formData.append('yearExpenseRentals', year);
      formData.append('expenseAmountRentals', amount);
      formData.append('apiType', 'uploadExpensesRentals');

      axios.post(`${server_app_api_php}/upload.php`, formData)
        .then(response => {
          setLoading(false);
          setSuccess(true);
          setBusinessLocationID('');
          setExpense('');
          setMonth('');
          setYear('');
          setAmount('');
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch(error => {
          setLoading(false);
          setError('Network error. Please check your internet connection.');
        });
    } else {
      setLoading(false);
      setError('Please fill all required fields');
    }
  };

  return (
    <>
      <Header />
      <main className="lg:ml-64 pt-16 min-h-screen bg-gray-50">
        <div className="p-6">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <div className="flex items-center space-x-4 mb-2">
                <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl">
                  <Wallet className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">Register Rentals Expenses</h1>
                  <p className="text-gray-600">Track and manage rental property expenses</p>
                </div>
              </div>
            </div>

            {/* Status Messages */}
            {success && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl">
                <div className="flex items-center space-x-3">
                  <CheckCircle className="w-5 h-5 text-green-600" />
                  <span className="text-green-800 font-medium">Expense registered successfully!</span>
                </div>
              </div>
            )}

            {error && (
              <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
                <div className="flex items-center space-x-3">
                  <AlertCircle className="w-5 h-5 text-red-600" />
                  <span className="text-red-800 font-medium">{error}</span>
                </div>
              </div>
            )}

            <div className="bg-white rounded-2xl shadow-lg p-6">
              {business_locationIDMain ? (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        <Building2 className="w-4 h-4 inline mr-2" />
                        Business Location
                      </label>
                      <select
                        className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                        value={businessLocationID}
                        onChange={(e) => setBusinessLocationID(e.target.value)}
                        required
                      >
                        <option value="">Select Business Location</option>
                        {businessLocations.map(location => (
                          <option key={location.businessLocationID} value={location.businessLocationID}>
                            {location.businessLocationName}
                          </option>
                        ))}
                      </select>
                    </div>

                    {businessLocationID && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            <TrendingUp className="w-4 h-4 inline mr-2" />
                            Expense Type
                          </label>
                          <select
                            className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                            value={expense}
                            onChange={(e) => setExpense(e.target.value)}
                            required
                          >
                            <option value="">Select Expense Type</option>
                            {expenses.map(exp => (
                              <option key={exp.expensesID} value={exp.expensesID}>
                                {exp.expenses}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            <Calendar className="w-4 h-4 inline mr-2" />
                            Month
                          </label>
                          <select
                            className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            required
                          >
                            <option value="">Select Month</option>
                            {months.map(m => (
                              <option key={m} value={m}>{m}</option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            <Calendar className="w-4 h-4 inline mr-2" />
                            Year
                          </label>
                          <select
                            className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            required
                          >
                            <option value="">Select Year</option>
                            {years.map(y => (
                              <option key={y} value={y}>{y}</option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            <DollarSign className="w-4 h-4 inline mr-2" />
                            Amount (ZMW)
                          </label>
                          <input
                            type="text"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter amount"
                            required
                          />
                        </div>
                      </>
                    )}
                  </div>

                  <button
                    type="submit"
                    disabled={loading || !businessLocationID || !expense || !month || !year || !amount}
                    className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white py-3 px-6 rounded-xl font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                  >
                    {loading ? 'Processing...' : 'Register Expense'}
                  </button>
                </form>
              ) : (
                <div className="text-center py-12">
                  <AlertCircle className="w-16 h-16 text-yellow-500 mx-auto mb-4" />
                  <h3 className="text-lg font-medium text-gray-900 mb-2">Business Location Required</h3>
                  <p className="text-gray-500">Please set a business location before registering expenses</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ModalUploadRentalsExpenseForm;